import { Autocomplete, TextField } from '@mui/material';

export type SearchableSelectOption = { id: string; label: string };

type Props = {
  label: string;
  value?: string | null;
  options: SearchableSelectOption[];
  onChange: (value: string) => void;
  size?: 'small' | 'medium';
  disabled?: boolean;
  required?: boolean;
};

export default function SearchableSelect({ label, value, options, onChange, size = 'medium', disabled, required }: Props) {
  return (
    <Autocomplete
      fullWidth
      size={size}
      options={options}
      value={options.find((option) => option.id === value) || null}
      disabled={disabled}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, current) => option.id === current.id}
      onChange={(_, option) => onChange(option?.id || '')}
      noOptionsText="Ничего не найдено"
      renderInput={(params) => <TextField {...params} label={label} required={required} placeholder="Начните вводить название" />}
    />
  );
}
